<template>
  <div>
    <div class="form-group">
      <div class="col-md-6 col-md-offset-3">
        <div class="floatlabel" :class="{ ' floatlabel-active': country }">
          <label for="country" class="control-label">{{ $t('Country') }}</label>
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <country-select
            id="country"
            v-model="country"
            class="form-control"
            name="country"
            required="required"
          />
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-md-6 col-md-offset-3">
        <div class="floatlabel" :class="{ ' floatlabel-active': market }">
          <label for="market" class="control-label">{{ $t('Market') }}</label>
          <!-- Hidden input needed here so that submitting is possible when the market select field is disabled -->
          <input type="hidden" name="market" :value="market" />
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <market-select
            id="market"
            v-model="market"
            class="form-control"
            name="market"
            required="required"
            :disabled="marketDisabled"
          />
          <div class="f-12 c-gray m-t-10 p-l-10 p-r-10">
            {{
              $t(
                'The market you choose will impact your currency, compliance and language settings, so make sure to pick the market that is closest to you.',
              )
            }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        (hasCountryWarningSlot && showCountryWarning) || (hasMarketWarningSlot && showMarketWarning)
      "
      class="bgm-lightgray p-15 text-center m-t-10"
    >
      <template v-if="hasCountryWarningSlot && showCountryWarning">
        <slot name="country-warning" />
      </template>
      <template v-else-if="hasMarketWarningSlot && showMarketWarning">
        <slot name="market-warning" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      country: '',
      market: '',
      marketDisabled: false,
    }
  },

  computed: {
    markets() {
      return currentMarkets
    },
    launchedCountries() {
      return currentMarketCountries
    },
    countryMarkets() {
      return launchedCountriesByMarket
    },
    httpCountry() {
      return clientHttpCountry
    },
    hasCountryWarningSlot() {
      return !!this.$slots['country-warning']
    },
    hasMarketWarningSlot() {
      return !!this.$slots['market-warning']
    },
    showCountryWarning() {
      if (!this.country) {
        return false
      }

      return !this.launchedCountries.includes(this.country.toLowerCase())
    },
    showMarketWarning() {
      if (!this.market || !this.country) {
        return false
      }

      const marketCountries = this.markets[this.market].countries
      return !marketCountries.includes(this.country.toLowerCase())
    },
  },

  watch: {
    country(value) {
      const market = this.countryMarkets[value.toLowerCase()]

      this.marketDisabled = !!market

      this.market = market ?? ''
    },
  },

  mounted() {
    // if we get country from the server and it's in the list of our countries
    if (this.httpCountry && Object.keys(countriesGlobalVar).includes(this.httpCountry)) {
      this.country = this.httpCountry
    }
  },
}
</script>

<style lang="scss" scoped>
// mimick input floatlabel for the inputs
.floatlabel {
  .form-control {
    height: 47px;
  }

  &.floatlabel-active {
    .form-control {
      padding-top: 20px !important;
      padding-left: 6px !important;
    }
  }
}
</style>
